import { useSelector } from 'react-redux';
import { selectRegionId } from '../selectors/offer';
import { EMultiPostingAvailablePlatforms, IMultiPostingPlatformsByRegion } from '../redux/types/multiPosting/types';
import * as React from 'react';
import { ApplicationContext } from '../components/ApplicationContext';
import { selectMultiPostingAvailablePlatforms } from '../selectors/publishTerms';

export const useMultiPostingPlatforms = (): string[] => {
  const { config } = React.useContext(ApplicationContext);
  const availablePlatforms = useSelector(selectMultiPostingAvailablePlatforms);
  const regionId = useSelector(selectRegionId);
  const platformsByRegion = config.get<IMultiPostingPlatformsByRegion>('addformConfig.multiPosting.platforms') || {};
  const platforms = platformsByRegion[String(regionId)];

  if (!platforms) {
    return [];
  }

  if (availablePlatforms === EMultiPostingAvailablePlatforms.Free) {
    return platforms.free;
  } else if (availablePlatforms === EMultiPostingAvailablePlatforms.All) {
    return platforms.paid.concat(platforms.free);
  }

  return [];
};
